/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SubscriptionUserControllerToggleAutoRenewMutationResponse,
  SubscriptionUserControllerToggleAutoRenew401,
} from '../types/SubscriptionUserControllerToggleAutoRenew.ts';

function getSubscriptionUserToggleAutoRenewUrl() {
  const res = { method: 'PATCH', url: `/api/user/telegram/subscriptions/toggle-auto-renew` as const };
  return res;
}

/**
 * {@link /api/user/telegram/subscriptions/toggle-auto-renew}
 */
export async function subscriptionUserToggleAutoRenew(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SubscriptionUserControllerToggleAutoRenewMutationResponse,
    ResponseErrorConfig<SubscriptionUserControllerToggleAutoRenew401>,
    unknown
  >({ method: 'PATCH', url: getSubscriptionUserToggleAutoRenewUrl().url.toString(), ...requestConfig });
  return res.data;
}
